import { CartListProps } from './CartList.types'

export const defaultProps: Partial<CartListProps> = {
  labelMap: {
    default: {
      icon: 'MdOutlineShoppingCart',
      label: ''
    },
    cash: {
      icon: 'MdOutlinePayments',
      label: 'cash payment'
    },
    credit: {
      icon: 'MdCreditCard',
      label: 'credit payment'
    }
  },
  emptyMessage: {
    icon: 'MdOutlineShoppingCart',
    message: 'Your cart is empty'
  },
  errorMessage: {
    icon: 'MdErrorOutline',
    message: 'There was an error loading the cart'
  },
  loadingMessage: {
    loader: true
  }
}
